const Footer = () => (
    <footer id="contact" className="contact">
        <div className="container">
            <div className="footer-top">
                <div className="row">
                    <div className="col-md-3 col-sm-6">
                        <div className="single-footer-widget">
                            <div className="footer-logo">
                                <a href="index.html">Car Blog</a>
                            </div>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin placerat posuere elit quis lobortis. 
                            </p>
                            <div className="footer-contact">
                                <p>hisukagon@gmail.com</p>
                                <p>+63 995 779 9021</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 col-sm-6">
                        <div className="single-footer-widget">
                            <h2>About Car Blog</h2>
                            <ul>
                                <li><a href="#a">about us</a></li>
                                <li><a href="#b">career</a></li>
                                <li><a href="#c">terms <span> of service</span></a></li>
                                <li><a href="#d">privacy policy</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-3 col-xs-12">
                        <div className="single-footer-widget">
                            <h2>top brands</h2>
                            <div className="row">
                                <div className="col-md-7 col-xs-6">
                                    <ul>
                                        <li><a href="#a">BMW</a></li>
                                        <li><a href="#b">lamborghini</a></li>
                                        <li><a href="#c">camaro</a></li>
                                        <li><a href="#d">audi</a></li>
                                        <li><a href="#e">infiniti</a></li>
                                        <li><a href="#f">nissan</a></li>
                                    </ul>
                                </div>
                                <div className="col-md-5 col-xs-6">
                                    <ul>
                                        <li><a href="#a">ferrari</a></li>
                                        <li><a href="#b">porsche</a></li>
                                        <li><a href="#c">land rover</a></li>
                                        <li><a href="#d">aston martin</a></li>
                                        <li><a href="#e">mersedes</a></li>
                                        <li><a href="#f">opel</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-offset-1 col-md-3 col-sm-6">
                        <div className="single-footer-widget">
                            <h2>news letter</h2>
                            <div className="footer-newsletter">
                                <p>
                                    Subscribe to get latest news  update and informations
                                </p>
                            </div>
                            <div className="hm-foot-email">
                                <div className="foot-email-box">
                                    <input type="text" className="form-control" placeholder="Add Email" />
                                </div>
                                <div className="foot-email-subscribe">
                                    <span><i className="fa fa-arrow-right"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-copyright">
                <div className="row">
                    
                    <div className="col-sm-6">
                        <div className="footer-social">
                            <a href="#a"><i className="fa fa-facebook"></i></a>
                            <a href="#b"><i className="fa fa-instagram"></i></a>
                            <a href="#c"><i className="fa fa-linkedin"></i></a>
                            <a href="#d"><i className="fa fa-pinterest-p"></i></a>
                            <a href="#e"><i className="fa fa-behance"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="scroll-Top">
            <div className="return-to-top">
                <i className="fa fa-angle-up" id="scroll-top" data-toggle="tooltip" data-placement="top" title="Back to Top" aria-hidden="true"></i>
            </div>
        </div>
    </footer>
);

export default Footer;
